import moment from "moment"

export const OTP_COUNTDOWN_DURATION_SECONDS = 60
export const TBILISI_COORDINATES = { lng: 44.783333, lat: 41.716667 }
export const EMPLOYEE_POSITIONS = {
  QappAdmin: "QappAdmin",
  Washer: "Washer",
  CarWashManager: "CarWashManager",
  CarWashAdmin: "CarWashAdmin",
  QappManager: "QappManager",
}

export interface ILaundryFormInitialValues {
  name: string
  logo: string
  address: string
  phone: string
  idNumber: string
  bankAccount: string
  email: string
  startTime: Date
  endTime: Date
  is24: boolean
  boxes: number | null
  district: string | null
  [key: string]: any
}

// Form Initial Values
export const LAUNDRY_FORM_INITIAL_VALUES: ILaundryFormInitialValues = {
  name: "",
  logo: "",
  address: "",
  phone: "",
  idNumber: "",
  bankAccount: "",
  email: "",
  startTime: moment(new Date()).set({ hour: 8, minute: 0 }).toDate(),
  endTime: moment(new Date()).set({ hour: 22, minute: 0 }).toDate(),
  is24: false,
  boxes: null,
  district: null,
}
